import { CustomEventTypes } from '../../types/CustomEvent'
import { isGTMPageview } from '../../types/GTM'

export const isPageViewSent = () =>
	window.dataLayer.some(
		(event) =>
			isGTMPageview(event) && event[1] === CustomEventTypes.LOAD_DATALAYER
	)
